import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImportsModule } from 'src/app/modules/shared/imports/imports.module';
import { CuotasRoutingModule } from './cuotas-routing.module';
import { CuotasComponent } from './cuotas/cuotas.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReportesComponent } from './reportes/reportes.component';


@NgModule({
  declarations: [
    CuotasComponent,
    ReportesComponent
  ],
  imports: [
    ImportsModule,
    CommonModule,
    CuotasRoutingModule,
    FormsModule, ReactiveFormsModule
  ]
})
export class CuotasModule { }
